import '../scss/frontend/passport-product.scss';

import 'bootstrap5';
import '@ungap/custom-elements';